import React from 'react';

import { useFormContext, useWatch } from 'react-hook-form';

import { Switch } from 'components/ui/switch';

import {
  EOfferFormatKey,
  IStoreSettingsFormValues
} from '../../../StoreSettings.types';
import {
  ABBREVIATION_SWITCH_CLASSNAME,
  getAbbreviationToggleTestId
} from '../AbbreviationsSettingsV2.consts';
import {
  IAbbreviationToggleField,
  QuantityFieldPath
} from '../AbbreviationsSettingsV2.types';
import { getQuantityFieldPath } from '../AbbreviationsSettingsV2.utils';

interface IAbbreviationToggleCardProps {
  sectionKey: EOfferFormatKey;
  field: IAbbreviationToggleField;
  onToggle: (path: QuantityFieldPath, value: boolean) => void;
}

export const AbbreviationToggleCard = ({
  sectionKey,
  field,
  onToggle
}: IAbbreviationToggleCardProps): React.ReactElement => {
  const { control } = useFormContext<IStoreSettingsFormValues>();
  const fieldPath = getQuantityFieldPath(sectionKey, field.key);
  const isChecked = Boolean(useWatch({ control, name: fieldPath }));

  return (
    <div className="flex h-[58px] w-full items-center justify-between rounded-[10px] border border-base-border px-[17px]">
      <span className="text-sm font-medium text-base-foreground">
        {field.label}
      </span>
      <Switch
        checked={isChecked}
        onCheckedChange={(checked): void => onToggle(fieldPath, checked)}
        className={ABBREVIATION_SWITCH_CLASSNAME}
        data-testid={getAbbreviationToggleTestId(field.key)}
      />
    </div>
  );
};
